module.exports = __webpack_public_path__ + "static/media/pdf-video-img.b9ec5ffd.png";